import API from '@/api/index';

const uploadFile = {
  state: {},

  mutations: {},

  actions: {
    uploadFileImage({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.uploadFile
          .uploadFileImage(data)
          .then(response => {
            let result = response.data;
            resolve(result.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    uploadMultipleFile({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.uploadFile
          .uploadMultipleFile(data)
          .then(response => {
            let result = response.data;
            resolve(result.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    uploadAvatar({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.uploadFile
          .uploadAvatar(data)
          .then(response => {
            let result = response.data;
            resolve(result.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    deleteImageUrl({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.uploadFile
          .deleteImageUrl(data)
          .then(response => {
            let result = response.data;
            resolve(result.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};

export default uploadFile;
